import React from "react";

import "./HomeWhyUs.css";

const HomeWhyUs = () => {
  return (
    <div className="WhyUs ">
      <div className="flex flex-col md:flex-row items-center md:items-start justify-center md:justify-start px-4">
        <p className="paraText text-black text-lg mb-2 p-16 md:mb-4 w-full md:w-1/2">
          When SILVERLINE TOURS & TRAVELS began in 2015, our focus was clear: to
          cater to a demographic often overlooked by mainstream travel agencies.
          Our initial clients consisted primarily of seniors, retirees, and
          housewives, individuals with limited budgets but boundless curiosity.
          Many had spent their lives confined to familiar surroundings, yearning
          for the chance to explore the wider world. Recognizing this unmet
          need, we embarked on a mission to empower these silver-haired
          adventurers, offering affordable yet enriching travel experiences.
          <br></br>
           As
          our journey unfolded, we evolved, expanding our offerings while
          remaining true to our founding principles. Today, SILVERLINE TOURS & TRAVELS continues
          to champion the spirit of exploration, ensuring that age is never a
          barrier to discovering new horizons.
        </p>
      </div>
    </div>
  );
};

export default HomeWhyUs;
